import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanyIntegrationsModel }  from '../companies/models/company.integrations';
import { SessionService }            from '../sessions/session.service';
import { VVGarageLocationModel }     from './typings/vv-garage.location';
import { VVGarageService }           from './vv-garage.service';
import { VVGarageSettingsComponent } from './vv-garage.settings.component';

export const VVGarageStates : Array<NgHybridStateDeclaration> = [
  {
    component: VVGarageSettingsComponent,
    name     : 'app.vv-garage',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ VVGarageService ],
        resolveFn: ( vvGarageService : VVGarageService ) : ng.IPromise<CompanyIntegrationsModel> => vvGarageService.getIntegrations(),
        token    : 'settings'
      },
      {
        deps     : [ VVGarageService ],
        resolveFn: ( vvGarageService : VVGarageService ) : ng.IPromise<VVGarageLocationModel> => vvGarageService.getLocations(),
        token    : 'locations'
      }
    ],
    url: '/vv-garage'
  }
];
